<template>
  <div class="nprogress-container"></div>
</template>

<script>
export default {
  name: 'nprogress-container'
}
</script>

<style lang="css">
@import '~nprogress/nprogress.css';
</style>



// WEBPACK FOOTER //
// NprogressContainer.vue?28acfc9e